import React from 'react';
import GridMenu from '../Menu/GridMenu';
import './HomeEyeCheckUp.scss';
import { setDataAttr } from '../../../../utils/helper';

const HomeEyeCheckUp = props => {
  const { updateNavDtm, parentMenu, menuData, section, cta } = props;
  const parentKey = Object.keys(parentMenu).toString();
  const fetchMenu = menuData.data?.map((data, index) => {
    const dataAttr =
      data?.gaObj && Object.keys(data?.gaObj).length > 0 ? setDataAttr(data?.gaObj) : null;
    return (
      <div
        key={index}
        className={`home-eye-checkup ${section.replace(/ /g, '').replace(/-/g, '').toLowerCase()}`}
      >
        {parentMenu[parentKey] && parentMenu[parentKey].sliderType ? (
          <div className="display-flex align-items-center" style={{ height: '100%' }}>
            <div
              className="layout text-black no-decoration align-items-center"
              style={{ width: '100%', height: '100%' }}
            >
              <div className="right-content">
                <h3 className="heading-text">{data?.headingText}</h3>
                <p
                  dangerouslySetInnerHTML={{ __html: data?.supportText }}
                  className="lh-20 support-text fs16"
                ></p>
                <div className="display-flex button-text align-items-center justify-content-center">
                  <button
                    className="btn btn-navigation"
                    onClick={e => {
                      updateNavDtm(
                        section,
                        null,
                        null,
                        null,
                        null,
                        e,
                        section + ' ' + data?.buttonText
                      );
                      window.location.href = data?.url;
                    }}
                  >
                    {data?.buttonText}
                  </button>
                  {data?.boldText && <h5 className="light-dark">{data?.boldText}</h5>}
                </div>
              </div>
              <div className="right-content imageGrid display-flex align-items-center margin-l35 margin-r20">
                {data?.sliderImg && (
                  <GridMenu
                    menuData={data?.sliderImg}
                    parentMenu={parentMenu[parentKey]}
                    section={section}
                    updateNavDtm={updateNavDtm}
                  />
                )}
              </div>
            </div>
            <div className="BannerDiv">
              <a href={menuData.imgUrl}>
                <img
                  alt={menuData.imgAlt}
                  className="BannerImg img lazy-load-image"
                  src="https://static1.lenskart.com/media/desktop/img/GreyBackground.png"
                  data-src={menuData.img}
                />
              </a>
            </div>
          </div>
        ) : (
          <a
            className="getGaData layout justify-content-between text-black no-decoration"
            href={data?.url}
            onClick={e =>
              updateNavDtm(section, null, null, null, cta, e, section + ' ' + data?.buttonText)
            }
            {...dataAttr}
          >
            <div className="checkup-image-section">
              <img
                alt={data?.image?.imgAlt}
                className="img lazy-load-image"
                src="https://static1.lenskart.com/media/desktop/img/GreyBackground.png"
                data-src={data?.image?.src}
              />
            </div>
            <div className="margin-l35 right-content">
              <h3 className="heading-text">{data?.headingText}</h3>
              <p
                className="lh-20 support-text margin-b15"
                dangerouslySetInnerHTML={{ __html: data?.supportText }}
              ></p>
              <div className="display-flex button-text align-items-center justify-content-center">
                <button className="btn btn-navigation">{data?.buttonText}</button>
                {/* <span className="mid-line"></span>
                {data?.boldText && <h5 className="light-dark margin-b15">{data?.boldText}</h5>} */}
              </div>
            </div>
          </a>
        )}
      </div>
    );
  });
  return <div className="nav-level-acc big-screen-wrapper">{fetchMenu}</div>;
};

HomeEyeCheckUp.defaultProps = {
  parentMenu: {},
};

export default HomeEyeCheckUp;
